/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input } from '@angular/core'
import { PriceDataResponse } from '../models/price-data'

interface ChartData {
  date: Date
  value: number | null
}

@Component({
  selector: 'pricing-charts',
  templateUrl: './pricing-charts.component.html',
  styleUrls: ['./pricing-charts.component.scss'],
})
export class PricingChartsComponent {
  @Input() _priceData: PriceDataResponse[] = []

  @Input() set priceData(priceData: PriceDataResponse[]) {
    this._priceData = priceData
    this.updateCharts()
  }

  @Input() beginDate = ''
  @Input() endDate = ''

  priceChartOptions: any
  yieldChartOptions: any
  durationChartOptions: any

  updateCharts() {
    this.priceChartOptions = this.makeChartOptions(
      this.makePriceChartData(this._priceData),
      'Price',
    )
    this.yieldChartOptions = this.makeChartOptions(
      this.makeYieldChartData(this._priceData),
      'Yield',
    )
    this.durationChartOptions = this.makeChartOptions(
      this.makeDurationChartData(this._priceData),
      'Duration',
    )
  }

  makePriceChartData(priceData: PriceDataResponse[]): ChartData[] {
    return priceData.map(data => {
      const chartData: ChartData = {
        date: new Date(data.pricingDate),
        value: data.price,
      }
      return chartData
    })
  }

  makeYieldChartData(priceData: PriceDataResponse[]): ChartData[] {
    return priceData.map(data => {
      const chartData: ChartData = {
        date: new Date(data.pricingDate),
        value: data.yield,
      }
      return chartData
    })
  }

  makeDurationChartData(priceData: PriceDataResponse[]): ChartData[] {
    return priceData.map(data => {
      const chartData: ChartData = {
        date: new Date(data.pricingDate),
        value: data.duration,
      }
      return chartData
    })
  }

  private makeChartOptions(chartData: ChartData[], type: string) {
    return {
      title: { enabled: true, text: type, fontSize: 10 },
      data: chartData,
      series: [
        {
          type: 'line',
          xKey: 'date',
          yKey: 'value',
        },
      ],
      axes: [
        {
          position: 'bottom',
          type: 'time',
          tick: { count: 10 },
          label: { rotation: 90, format: '%x', fontSize: 10 },
          min: new Date(this.beginDate),
          max: new Date(this.endDate),
        },
        {
          position: 'left',
          type: 'number',
          label: { fontSize: 10 },
        },
      ],
      legend: {
        enabled: false,
      },
    }
  }
}
